import proj4 from 'proj4';
import inside from '@turf/inside';
import polygon from '@turf/bbox-polygon';
import { EPSG3067 } from '../../config';

export default function filterByBoundingBox(event, bbox) {
  const bboxPolygon = polygon(bbox);
  const eventCoord = proj4(EPSG3067, [event.LAT, event.LON]);
  const inputPoint = { type: 'Feature', geometry: { type: 'Point', coordinates: eventCoord } };

  return inside(inputPoint, bboxPolygon) === true;
}



// WEBPACK FOOTER //
// ./src/services/filters/filterByBoundingBox.js